import React from "react";
import '../../entrydoor.css';
//import "./DoorLiteSearch.css"; // Add CSS for styling alignment


const DoorLiteSearch = ({ placeholder = "Search Side Lite...", onChange }) => {
    return (
        <div className="doorlite-search-container">
            <input
                type="text"
                className="doorlite-search-input"
                placeholder={placeholder}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    );
};

export default DoorLiteSearch;

